var _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack152({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "9.61 8 15 2.07 11.79 2.07 8 6.24 4.21 2.07 1 2.07 6.39 8 1 13.93 4.21 13.93 8 9.77 11.79 13.93 15 13.93 9.61 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack152);
export default __webpack_public_path__ + "static/media/Symbolpack_1_52.86bdf5d961a5236df8ca5980f27a9e77.svg";
export { ForwardRef as ReactComponent };